import React, { createContext, useContext, useEffect, useLayoutEffect, useRef } from "react";
import { suspendedNativePickerType } from "./iosWebkit";
import { NATIVE_PICKER_INPUT_CLASS, NATIVE_PICKER_WRAP_CLASS } from "./formFields";

const NativePickerSuspendContext = createContext(false);

export function NativePickerSuspendProvider({ suspended, children }) {
  return <NativePickerSuspendContext.Provider value={Boolean(suspended)}>{children}</NativePickerSuspendContext.Provider>;
}

/** Wraps date/time inputs so iOS WebKit respects grid column width on iPad. */
export default function NativePickerInput({ style, className = "", type = "text", readOnly = false, inputMode, ...rest }) {
  const suspended = useContext(NativePickerSuspendContext);
  const renderedType = suspendedNativePickerType(type, suspended);
  const suspendPicker = renderedType !== type;
  const inputRef = useRef(null);

  useLayoutEffect(() => {
    if (!suspendPicker) return;
    const node = inputRef.current;
    if (node && document.activeElement === node && typeof node.blur === "function") node.blur();
  }, [suspendPicker]);

  useEffect(() => {
    const node = inputRef.current;
    return () => {
      if (node && typeof node.blur === "function") node.blur();
    };
  }, []);

  return (
    <div className={NATIVE_PICKER_WRAP_CLASS}>
      <input
        key={renderedType}
        ref={inputRef}
        {...rest}
        className={[NATIVE_PICKER_INPUT_CLASS, className].filter(Boolean).join(" ")}
        style={style}
        type={renderedType}
        readOnly={readOnly || suspendPicker}
        inputMode={suspendPicker ? "none" : inputMode}
      />
    </div>
  );
}
